import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowDown } from 'lucide-react';
import { buttonVariants, Button } from '@/components/ui/button';

const HERO_IMG = '/image-aurederma.webp';

export const Hero = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden);
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  return (
  <section className="relative pt-28 md:pt-36 pb-14 md:pb-24 overflow-hidden">
    <div className="mx-auto container-editorial">
      {/* Top meta line */}
      <div className="flex items-center justify-between mb-10 md:mb-14">
        <div className="label-eyebrow flex  items-center gap-2 !text-[0.72rem]">
          <span className="w-1.5 h-1.5 rounded-full bg-sienna" />
          Healthcare-First Design Studio · Amravati, India
        </div>
        <div className="label-eyebrow hidden md:block !text-[0.72rem]">Vol. 01 — Healthcare, First</div>
      </div>

      {/* Headline */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-end">
        <div className="lg:col-span-8">
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.7, 0, 0.2, 1] }}
            className="display-hero text-[clamp(2.5rem,10vw,9.5rem)] leading-[0.9] tracking-tight text-balance"
          >
            Websites built <br className="hidden md:block" />
            <span className="italic-serif text-sienna">the way</span> good <br className="hidden md:block" />
            clinics <span className="italic-serif text-sienna">practice</span>.
          </motion.h1>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="lg:col-span-4 lg:pb-4"
        >
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-md">
            TechsFlow is a frontend-first studio that designs and builds
            unhurried, considered websites — primarily for dermatologists, dental,
            and aesthetic clinics who want their online first impression to feel like their
            reception, not a template.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link to="/contact" className={buttonVariants({ variant: 'editorial' })}>
              Get a site like this <ArrowUpRight className="w-4 h-4" />
            </Link>
            <Link to="/work" className={buttonVariants({ variant: 'ghost-editorial' })}>
              See recent work
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
  );
};

export default Hero;
